/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { convertRawDataToPlan } from '@fai/friendli-suite/features/products/serverless-endpoints/plan';
import {
  TeamServerlessEndpointsPlanDocument,
  type TeamServerlessEndpointsPlanQuery,
  type TeamServerlessEndpointsPlanQueryVariables,
} from '@fai/friendli-suite/generated/client/graphql';
import client from '@fai/friendli-suite/shared/apollo/base-link';

export async function getProductServerlessEndpointsPlan({ teamId }: { teamId: string }) {
  const { data } = await client.query<
    TeamServerlessEndpointsPlanQuery,
    TeamServerlessEndpointsPlanQueryVariables
  >({
    query: TeamServerlessEndpointsPlanDocument,
    variables: { teamId },
    fetchPolicy: 'network-only',
  });

  const userTeamData = data?.clientSession?.user.team;
  const productServerlessData = userTeamData?.team.serverlessSubplan;

  const teamRole = userTeamData?.role;
  const isProductAccessible = userTeamData?.productAccess?.serverlessEndpoints;
  const productPlan = productServerlessData?.tier;
  const productState = productServerlessData?.state;

  return convertRawDataToPlan({
    teamRole,
    isProductAccessible,
    productPlan,
    productState,
  });
}
